// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_RtO","cls2":"AuthorHeader-cls2_ZwB AuthorHeader-cls1_RtO"};